@if (!authorsDetails) {
  <div class="collections" mulo-page-line>
    <ng-container>
      <mat-icon class="icon" muloSvgViewbox svgIcon="bookmark-star"></mat-icon>
      {{ 'research.portal.fulldisplay.collections.line' | translate }}&nbsp;
      <a [queryParams]="{ institution: institutionCode }" [routerLink]="collections[0].permalink">
        {{ 'research.collection.' + collections[0].code + '.name' | translate }}
      </a>
    </ng-container>
    @if (collections.length > 1) {
      <button (click)="toggleAuthorsDetails()" class="details-toggle toggle-button" color="primary" mat-button>
        @if (collections.length > 2) {
          {{ 'research.portal.fulldisplay.collections.more' | translate : { value: collections.length - 1 } }}
        }
        @if (collections.length === 2) {
          {{ 'research.portal.fulldisplay.collections.more.single' | translate }}
        }
      </button>
    }
  </div>
}

@if (authorsDetails) {
  <div class="details" mulo-page-line>
    @for (collection of collections; track collection; let i = $index) {
      <div class="margin-bottom-xs">
        <p>
          <mat-icon class="icon" muloSvgViewbox svgIcon="bookmark-star"></mat-icon>
          <a [queryParams]="{ institution: institutionCode }" [routerLink]="collection.permalink">
            {{ 'research.collection.' + collection.code + '.name' | translate }}
          </a>
        </p>
      </div>
    }
    <button
      (click)="toggleAuthorsDetails()"
      class="details-toggle has-icon"
      color="primary"
      hideOnPrint
      mat-raised-button
      >
      <mat-icon svgIcon="chevron-up"></mat-icon>
      {{ 'research.portal.fulldisplay.collections.hideDetails' | translate }}
    </button>
  </div>
}
